export { EntityDiagram } from './EntityDiagram';
export type { EntityDiagramProps } from './types';
